import React from "react";
import PropTypes from "prop-types";
import MenuList from "@material-ui/core/MenuList";
import MenuItem from "@material-ui/core/MenuItem";
import Divider from "@material-ui/core/Divider";
import { withStyles } from "@material-ui/core/styles";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt, faBuilding } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

const menuItemGroups = {
  Käyttäjä: {
    items: {
      "Valitse toimipiste": {
        icon: faBuilding,
        to: "/valitseToimipiste"
      },
      "Kirjaudu ulos": {
        icon: faSignOutAlt,
        to: "/login",
        onClick: _ => localStorage.removeItem("access_token")
      }
    }
  }
};

const styles = theme => ({
  menuItem: {
    "&:focus": {
      backgroundColor: theme.palette.primary.main,
      "& $primary, & $icon": {
        color: theme.palette.common.white
      }
    },
    padding: theme.spacing(5)
  },
  primary: {},
  icon: {},
  link: {
    textDecoration: "none",
    color: theme.palette.common.black
  }
});

class ListItemComposition extends React.Component {
  render() {
    const { classes } = this.props;

    return (
      <MenuList style={{ width: "100%" }}>
        {Object.keys(menuItemGroups).map(migKey => {
          const mig = menuItemGroups[migKey];
          const items = mig.items;
          return [
            Object.keys(items).map(iKey => {
              const i = items[iKey];
              return (
                <Link
                  to={i.to}
                  onClick={_ => i.onClick && i.onClick().bind(this)}
                  className={classes.link}
                >
                  <MenuItem className={classes.menuItem}>
                    <ListItemIcon className={classes.icon}>
                      <FontAwesomeIcon icon={i.icon} />
                    </ListItemIcon>
                    <ListItemText
                      classes={{ primary: classes.primary }}
                      primary={iKey}
                    />
                  </MenuItem>
                </Link>
              );
            }),
            <Divider />
          ];
        })}
      </MenuList>
    );
  }
}

ListItemComposition.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ListItemComposition);
